// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tag[data-v-38b00412]{border-style:solid;border-width:1px;height:-moz-fit-content;height:fit-content;padding:4px 12px;vertical-align:bottom;width:-moz-fit-content;width:fit-content}.tag__delete[data-v-38b00412]{margin-left:6px;margin-right:-6px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
